import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import {moveNextReelPage, updateUserMetrics} from "../../../store/actions/creator/creatorExperienceBuilder";
import clsx from 'clsx';
import UtilService from '../../../helper/service';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, Theme } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import roles from "../../../helper/roles";
import {useCallback} from "react";

const ActiveTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#212D40',
    fontSize: 11,
    fontFamily: 'roboto-bold'
  },
}))(Tooltip);

const InactiveTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#D9D9D9',
    fontSize: 11,
    fontFamily: 'roboto-bold'
  },
}))(Tooltip);

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  inactiveNormal: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#F0F0F0',
    marginTop: 18,
  },
  inactiveSmall: {
    width: 17,
    height: 17,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#F0F0F0',
    zIndex: -1,
  },
  activeNormal: {
    width: 90,
    height: 90,
    borderRadius: 45,
    border: '4px solid #017AEF',
    background: '#F0F0F0',
    marginTop: 50,
  },
  activeSmall: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #017AEF',
    background: '#F0F0F0',
  },
  activeFillNormal: {
    width: 90,
    height: 90,
    borderRadius: 45,
    background: '#017AEF',
    zIndex: 100,
    marginTop: 50,
  },
  completedNormal: {
    width: 35,
    height: 35,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#D9D9D9',
    zIndex: 10,
    marginTop: 18,
    '&:hover': {
      cursor: 'pointer',
      borderColor: "#017AEF"
    }
  },
  completedSmall: {
    zIndex: 10,
    width: 17,
    height: 17,
    borderRadius: 18,
    border: '4px solid #D9D9D9',
    background: '#D9D9D9',
    
    '&:hover': {
      cursor: 'pointer',
      borderColor: "#017AEF"
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  mt0:{
    marginTop: 1,
    marginBottom: 30
  },
  mb35: {
    marginBottom: 35
  }
})
);

function CreatorSidebar() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { page, userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { reelsLastActivePage } = userMetrics;
  const { totalExperienceCount } = useSelector((state: any) => state.experience);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const onWheel = (e: any) => {
    const targetPage = e.deltaY < 0 ? page - (page !== 0 ? 1 : 0) : page + (page < UtilService.detectSidebarReelsConfig().length ? 1 : 0);
    onMovePage(targetPage)
  };

  const onMovePage = useCallback((nextPage: number) => {
    if ((UtilService.detectSidebarReelsConfig().length - 1) >= nextPage && reelsLastActivePage >= nextPage ) {
      dispatch(moveNextReelPage(nextPage));
    }
  }, [reelsLastActivePage]);

  const checkTrialFirstTimeBuilder = () => {
    return UtilService.checkTrialAccess(loginUserData, roles['trial']['builder'])
      && totalExperienceCount !== null
      && totalExperienceCount === 0
  };

  const checkAndGoPage = (pageId: number) => {
    onMovePage(pageId);
  };

  const goFirstChoicePage = () => {
    dispatch(updateUserMetrics('trialFirstStep', true));
    dispatch(updateUserMetrics('myOwn', false));
    dispatch(updateUserMetrics('otherSubmitted', false));
    dispatch(updateUserMetrics('item', ''));
    dispatch(updateUserMetrics('content', ''));
    dispatch(updateUserMetrics('path', 0));
    dispatch(moveNextReelPage(0));
  };

  return (
    <div className={classes.root+" reels_builder_steps" } onWheel={onWheel}>
      <div className='builder-sideBar-container'>

        <div className={clsx(classes.content)} onClick={() => checkTrialFirstTimeBuilder() && goFirstChoicePage()}>
          {page !== 0 && <img src={'/assets/icons/onboarding/progressbar/builder-inactive-first-img.svg'} alt="{img}" style={{ marginTop: 18 }}/>}
          {page === 0 && <img src={'/assets/icons/onboarding/progressbar/builder-active-first-img.svg'} alt="{img}" style={{ marginTop: 18 }}/>}
        </div>
        
        {
          UtilService.detectSidebarReelsConfig().map((item: any, index: number) =>
            <div className={classes.content} key={index} onClick={()=> index === 0 ? checkAndGoPage(item.pageId) : onMovePage(item.pageId)}>

              {page !== item.pageId && item.inactive && <img src={'/assets/icons/onboarding/progressbar/' + item.inactive} alt="{img}" style={{ marginTop: index !== 0 ? 18 : 0 }}/>}
              {page === item.pageId && item.active && <img src={'/assets/icons/onboarding/progressbar/' + item.active} alt="{img}" style={{ marginTop: index !== 0 ? 40 : 0 }}/>}

              {page !== item.pageId && !item.inactive && (
                page > item.pageId ? (
                  <ActiveTooltip title={item.hoverName} placement="right" TransitionComponent={Fade} TransitionProps={{ timeout: 1000 }}>
                    <div className={classes.completedNormal} />
                  </ActiveTooltip>
                ) : (
                  <InactiveTooltip title={item.hoverName} placement="right" TransitionComponent={Fade} TransitionProps={{ timeout: 1000 }}>
                    <div className={classes.inactiveNormal} />
                  </InactiveTooltip>
                )
              )} 
              {page === item.pageId && !item.active && <div className={clsx((UtilService.builderSidebar(userMetrics, item.stepKey[0]) ? classes.activeFillNormal : classes.activeNormal), item.stepKey.length === 1 && classes.mb35)} />}

              {item.stepKey.length > 1 && <div className={page !== item.pageId ? (page > item.pageId ? classes.completedSmall : classes.inactiveSmall) : clsx((UtilService.builderSidebar(userMetrics, item.stepKey[0]) ? classes.activeSmall : classes.inactiveNormal), classes.mt0)} />}

            </div>
          )
        }
      </div>

    </div>

  )

}

export default CreatorSidebar;